export default "__VITE_ASSET__DCNULL7___"